module.exports = __webpack_public_path__ + "static/media/title-class.92139e58.png";